module.exports = __webpack_public_path__ + "static/img/banner_1.27051ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/banner_1.jpg
// module id = F6jD
// module chunks = 1 2 3 4 5 6 7 8 9